// extracted by mini-css-extract-plugin
export var container = "_e2-1";
export var cornerButtonContainer = "_e2-6";
export var disabled = "_e2-2";
export var dragActive = "_e2-3";
export var fileContainer = "_e2-5";
export var hiddenInput = "_e2-4";
export var widthContainer = "_e2-0";